export default class IcoreCF7ConditionalLogic extends HTMLElement {
    conditions = {
        showInput: null,
        inputName: null,
        inputValue: null
    }
    form = null;
    inputElements = [];

    constructor() {
        super();

        this.conditions.showInput = this.getAttribute('show');
        const conditions = this.conditions.showInput.split(':');
        if ( conditions.length !== 2 ) {
            console.info('The "show" attribute on <icore-cf7-conditional-logic> must be in the format "inputName:inputValue".');
            return;
        }
        this.conditions.inputName = conditions[0];
        this.conditions.inputValue = conditions[1];
        this.form = this.closest('form.wpcf7-form');
        this.inputElements = this.form.querySelectorAll(`[name="${this.conditions.inputName}"]`);

        this.removeAttribute('show');
        this.classList.add('icore-conditional-logic-init', 'icore-cl-rdy');
    }

    connectedCallback() {
        if ( !this.inputElements.length ) {
            console.info(`Input element with name "${this.conditions.inputName}" not found for <icore-cf7-conditional-logic>.`);
            return;
        }

        this.inputElements.forEach( inputEl => {
            // Initial check
            this.#evaluateCondition(inputEl);

            // Listen for changes
            inputEl.addEventListener('change', this.#evaluateCondition.bind(this, inputEl));
        });
    }

    disconnectedCallback() {
        if ( this.inputElements.length ) {
            this.inputElements.forEach( inputEl => {
                inputEl.removeEventListener('change', this.#evaluateCondition.bind(this, inputEl));
            });
        }
    }

    #evaluateCondition(inputEl, evt) {
        let inputValue = inputEl.value;

        if (
            inputEl.type.toLowerCase() === 'checkbox' ||
            inputEl.type.toLowerCase() === 'radio'
        ) {
            inputValue = inputEl.checked ? inputEl.value : '';
        }

        if ( inputValue === this.conditions.inputValue ) {
            this.classList.add('icore-conditional-logic-show');
            this.style.display = '';
        } else {
            this.classList.remove('icore-conditional-logic-show');
            this.style.display = 'none';
        }
    }
}